// Plik: frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Komponenty stron
import HomePage from './pages/HomePage';
import RegistrationForm from './pages/RegistrationForm';
import ThankYouPage from './pages/ThankYouPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ParticipantsList from './pages/admin/ParticipantsList';
import SlotManagement from './pages/admin/SlotManagement';
import Statistics from './pages/admin/Statistics';
import SiteSettings from './pages/admin/SiteSettings';

// Kontekst uwierzytelnienia
import { AuthProvider, useAuth } from './context/AuthContext';

// Komponent chronionej trasy
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          {/* Publiczne trasy */}
          <Route path="/" element={<HomePage />} />
          <Route path="/rejestracja" element={<RegistrationForm />} />
          <Route path="/dziekujemy" element={<ThankYouPage />} />
          
          {/* Trasy administratora */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/uczestnicy" element={
            <ProtectedRoute>
              <ParticipantsList />
            </ProtectedRoute>
          } />
          <Route path="/admin/terminy" element={
            <ProtectedRoute>
              <SlotManagement />
            </ProtectedRoute>
          } />
          <Route path="/admin/statystyki" element={
            <ProtectedRoute>
              <Statistics />
            </ProtectedRoute>
          } />
          <Route path="/admin/ustawienia" element={
            <ProtectedRoute>
              <SiteSettings />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;